var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRunDetailsMetricsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0C14.4 -6.99431e-08 14.7616 0.238397 14.9191 0.606081L17.6594 7L21 7C21.5523 7 22 7.44771 22 8C22 8.55228 21.5523 9 21 9L17 9C16.6 9 16.2384 8.7616 16.0809 8.39392L14 3.53859L8.91915 15.3939C8.76157 15.7616 8.40003 16 8 16C7.59997 16 7.23844 15.7616 7.08086 15.3939L4.3406 9L1 9C0.447715 9 9.65645e-08 8.55229 0 8C-9.65645e-08 7.44772 0.447715 7 1 7L5 7C5.40003 7 5.76157 7.2384 5.91915 7.60608L8 12.4614L13.0809 0.606081C13.2384 0.238397 13.6 6.99432e-08 14 0Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunDetailsMetricsIcon);
export default __webpack_public_path__ + "static/media/RunDetailsMetricsIcon.8e7b7455a3c5b9ac438e8d587cd9479f.svg";
export { ForwardRef as ReactComponent };